<template lang="pug">
  b-card
    b-container.white-space(fluid="fluid")
      template(v-if="bIsLoading === true")
        loading(:height="200")
      template(v-else)
        //- エラーメッセージ表示用
        app-messages(:errorMessages="errors")
        b-form-text.ml-3.mb-3 ※お申し込みフォームから受け付けている商品以外は画面に表示されません。
        b-row
          b-col
            //- プラン情報
            template(v-if="hasPlan === true")
              h5.ml-3.py-2.font-weight-bold.border-top.border-bottom.plan-title-bg-color
                template(v-if="'light_user' in this.objContract === true || ('neo' in this.objContract === true && 'neo_user' in this.objContract.neo === true)") ライト
                template(v-if="'standard_user' in this.objContract === true") スタンダード
                template(v-if="'premium_user' in this.objContract === true") プレミアム
                template(v-if="'chatplus_user' in this.objContract === true") チャットプラス
              img.ml-3.mb-1(v-if="hasPlan === true", src="@/assets/images/logo_desknetsneo_clear_background.png")
              img.ml-2(v-if="'standard_user' in this.objContract === true || 'premium_user' in this.objContract === true", src="@/assets/images/logo_appsuite.png")
              img.ml-2(v-if="'premium_user' in this.objContract === true || 'chatplus_user' in this.objContract === true", src="@/assets/images/logo_chatluck.png")
              b-form-text.ml-3.py-2.px-2.my-2.border-top.border-bottom.border-plan.label-font-size {{objContract.light_user || objContract.standard_user || objContract.premium_user || objContract.chatplus_user || objContract.neo.neo_user}} ユーザー
              b-form-text(style="height: 30px;")

            template(v-if="hasNeoOption === true")
              h4.font-weight-bold desknet's NEO ご利用オプションサービス
              //- AppSuite
              template(v-if="'standard_user' in this.objContract !== true && 'premium_user' in this.objContract !== true && ('neo' in this.objContract === true && 'app_suite_user' in this.objContract.neo === true)")
                h5(:class="neo_service_title_class") 業務アプリ作成ツール AppSuite
                b-form-text(:class="neo_service_data_class") {{objContract.neo.app_suite_user}} ユーザー
                b-form-text(style="height: 30px;")

              //- ウェブ会議
              template(v-if="'web_conferencing' in objContract.neo === true")
                h5(:class="neo_service_title_class") desknet's NEO ウェブ会議
                b-form-text(:class="neo_service_data_class") {{objContract.neo.web_conferencing}} 会議室
                b-form-text(style="height: 30px;")

              //- desknet's DB
              template(v-if="'cloud_db_user' in objContract.neo === true")
                h5(:class="neo_service_title_class") desknet's DB
                b-form-text(:class="neo_service_data_class") {{objContract.neo.cloud_db_user}} ユーザー
                b-form-text(style="height: 30px;")

              template(v-if="'option' in objContract.neo === true")
                h5(:class="neo_service_title_class") オプションサービス
                //- RoomMgr
                b-form-text(v-if="'room_mgr' in objContract.neo.option === true", :class="neo_option_data_class") RoomMgr： 利用する

                //- 交通費・経費精算
                b-form-text(v-if="'expense_settlement' in objContract.neo.option === true", :class="neo_option_data_class") 交通費・経費精算： 利用する

                //- タイムカード＋CLOUZA
                b-form-text(v-if="'clouza' in objContract.neo.option === true", :class="neo_option_data_class") タイムカード＋CLOUZA
                  b-row
                    b-col(cols="1")
                    b-col
                      b-form-text.text-left ユーザー数 ： {{objContract.neo.option.clouza.user}} ユーザー
                      b-form-text.text-left(v-if="'clouza_company' in objContract.neo.option.clouza === true") CLOUZAお試し環境からの引き継ぎ ： {{objContract.neo.option.clouza.clouza_company}}
                      b-form-text.text-left.mb-2(v-if="'paid_leave_option' in objContract.neo.option.clouza === true") 有休管理＋申請承認オプション

                //- ディスク増設
                b-form-text(v-if="'disk' in objContract.neo.option === true", :class="neo_option_data_class") ディスク増設
                  b-row
                    b-col(cols="1")
                    b-col
                      b-form-text.text-left.mb-2 20GB × {{objContract.neo.option.disk.disk_size}} = {{20 * objContract.neo.option.disk.disk_size}}GB増設

                //- Sync for smartphones
                b-form-text(v-if="'sync' in objContract.neo.option === true", :class="neo_option_data_class") Sync for smartphones
                  b-row
                    b-col(cols="1")
                    b-col
                      b-form-text.text-left.mb-2 {{objContract.neo.option.sync.user}} ユーザー

                //- desknet'sドライブ ディスク増設
                b-form-text(v-if="'dn_drive' in objContract.neo.option === true", :class="neo_option_data_class") desknet'sドライブ ディスク増設
                  b-row
                    b-col(cols="1")
                    b-col
                      b-form-text.text-left.mb-2 20GB × {{objContract.neo.option.dn_drive.disk_size}} = {{20 * objContract.neo.option.dn_drive.disk_size}}GB増設

                b-form-text(style="height: 30px;", :class="neo_option_data_class")

              template(v-if="'security' in objContract.neo === true")
                h5(:class="neo_service_title_class") セキュリティオプション
                //- BASIC認証
                b-form-text(v-if="'basic' in objContract.neo.security === true", :class="neo_option_data_class") BASIC認証
                  b-row
                    b-col(cols="1")
                    b-col
                      b-form-text.text-left ユーザーID ： {{objContract.neo.security.basic.basic_id}}
                      basic-password(:password="objContract.neo.security.basic.basic_password")
                      template(v-if="'basic_except_ip' in objContract.neo.security.basic === true")
                        b-form-text.text-left 認証を除外するIPアドレス ：
                        b-form-text.text-left.ml-1 {{objContract.neo.security.basic.basic_except_ip}}

                //- 接続元IPアドレス制限
                b-form-text(v-if="'connect_permit_ip' in objContract.neo.security === true", :class="neo_option_data_class") 接続元IPアドレス制限
                  b-row
                    b-col(cols="1")
                    b-col
                      b-form-text.text-left 接続を許可するIPアドレス ：
                      b-form-text.text-left.ml-1 {{objContract.neo.security.connect_permit_ip}}

                //- セキュアブラウザ
                b-form-text(v-if="'secure' in objContract.neo.security === true", :class="neo_option_data_class") セキュアブラウザ
                  b-row
                    b-col(cols="1")
                    b-col
                      b-form-text.text-left {{contractDetailsFlgVar.secure_browser_terminal[objContract.neo.security.secure.secure_browser_terminal]}}
                      b-form-text.text-left(v-if="objContract.neo.security.secure.secure_browser_terminal === '02'") デバイス数 ： {{objContract.neo.security.secure.secure_browser_device}} デバイス
                      template(v-if="'secure_except_ip' in objContract.neo.security.secure === true")
                        b-form-text.text-left セキュアブラウザを適用しないIPアドレス ：
                        b-form-text.text-left.ml-1 {{objContract.neo.security.secure.secure_except_ip}}

                //- クライアント認証
                b-form-text(v-if="'client' in objContract.neo.security === true", :class="neo_option_data_class") クライアント認証
                  b-row
                    b-col(cols="1")
                    b-col
                      b-form-text.text-left デバイス数 ： {{objContract.neo.security.client.device}} デバイス
                      template(v-if="'cert_except_ip' in objContract.neo.security.client === true")
                        b-form-text.text-left 認証を除外するIPアドレス ：
                        b-form-text.text-left.ml-1 {{objContract.neo.security.client.cert_except_ip}}

                b-form-text(style="height: 30px;", :class="neo_option_data_class")

              template(v-if="'mail' in objContract.neo === true")
                h5(:class="neo_service_title_class") メールサービス
                //- WebARENA
                b-form-text(v-if="'arena' in objContract.neo.mail === true", :class="neo_option_data_class") WebARENA
                  b-row
                    b-col(cols="1")
                    b-col
                      b-form-text.text-left 利用ドメイン名 ： {{objContract.neo.mail.arena.wa_domain}}
                      b-form-text.text-left アカウント数 ： {{objContract.neo.mail.arena.account}} アカウント

                //- CYBERMAILΣ
                b-form-text(v-if="'cyber' in objContract.neo.mail === true", :class="neo_option_data_class") CYBERMAILΣ
                  b-row
                    b-col(cols="1")
                    b-col
                      b-form-text.text-left アカウント数 ： {{objContract.neo.mail.cyber.account}} アカウント
                      b-form-text.text-left.mb-2 メールボックス容量 ： {{objDefine.neo.mail.cyber.mailbox[objContract.neo.mail.cyber.mailbox]}} GB
                      b-form-text.font-weight-bold.text-left.mb-1(v-if="'options' in objContract.neo.mail.cyber === true") オプション
                      template(v-for="option in objContract.neo.mail.cyber.options")
                        b-form-text.text-left ・{{objDefine.neo.mail.cyber.options[option]}}を利用する
                          b-form-text.text-left.ml-3(v-if="option === '02'") （ {{objDefine.neo.mail.cyber.keep[objContract.neo.mail.cyber.keep]}}年保存 )

                b-form-text(style="height: 30px;", :class="neo_option_data_class")

              template(v-if="'mail_security' in objContract.neo === true")
                h5(v-if="'mailgates' in objContract.neo.mail_security === true", :class="neo_service_title_class") メールセキュリティサービス
                //- MAILGATES Σ
                b-form-text(:class="neo_option_data_class") MAILGATES Σ
                  b-row
                    b-col(cols="1")
                    b-col
                      b-form-text.text-left 利用ドメイン名 ： {{objContract.neo.mail_security.mailgates.mailgates_domain}}
                      b-form-text.text-left.mb-2 アカウント数 ： {{objContract.neo.mail_security.mailgates.account}} アカウント
                      b-form-text.font-weight-bold.text-left.mb-1 オプション
                      template(v-for="option in objContract.neo.mail_security.mailgates.options")
                        b-form-text.text-left ・{{objDefine.neo.mail_security.mailgates.options[option]}}を利用する

                b-form-text(style="height: 30px;", :class="neo_option_data_class")

            //- ChatLuck
            template(v-if="'chat' in objContract === true && 'chat_user' in objContract.chat === true")
              h5(:class="chat_service_title_class") ビジネスチャット ChatLuck
              b-form-text(:class="chat_service_data_class") {{objContract.chat.chat_user}} ユーザー
              b-form-text(style="height: 30px;")

            template(v-if="hasChatOption === true")
              h4.font-weight-bold ChatLuck ご利用オプションサービス

              template(v-if="'option' in objContract.chat === true")
                h5(:class="chat_service_title_class") オプションサービス
                //- ディスク増設
                b-form-text(v-if="'disk' in objContract.chat.option === true", :class="chat_option_data_class") ディスク増設
                  b-row
                    b-col(cols="1")
                    b-col
                      b-form-text.text-left.mb-2 20GB × {{objContract.chat.option.disk.disk_size}} = {{20 * objContract.chat.option.disk.disk_size}}GB増設

                b-form-text(style="height: 30px;", :class="chat_option_data_class")

              template(v-if="'security' in objContract.chat === true")
                h5(:class="chat_service_title_class") セキュリティオプション
                //- BASIC認証
                b-form-text(v-if="'basic' in objContract.chat.security === true", :class="chat_option_data_class") BASIC認証
                  b-row
                    b-col(cols="1")
                    b-col.pr-0.data-col-width-1
                      b-form-text.text-left ユーザーID ： {{objContract.chat.security.basic.basic_id}}
                      basic-password(:password="objContract.chat.security.basic.basic_password")
                      template(v-if="'basic_except_ip' in objContract.chat.security.basic === true")
                        b-form-text.text-left 認証を除外するIPアドレス ：
                        b-form-text.text-left.ml-1 {{objContract.chat.security.basic.basic_except_ip}}

                //- 接続元IPアドレス制限
                b-form-text(v-if="'connect_permit_ip' in objContract.chat.security === true", :class="chat_option_data_class") 接続元IPアドレス制限
                  b-row
                    b-col(cols="1")
                    b-col
                      b-form-text.text-left 接続を許可するIPアドレス ：
                      b-form-text.text-left.ml-1 {{objContract.chat.security.connect_permit_ip}}

                b-form-text(style="height: 30px;", :class="chat_option_data_class")

        b-button.float-right.mr-5.mb-3(v-if="enableCreateQuote === true", pill, variant="outline-success", size="lg", :disabled="bIsLoadingQuote", @click="createQuote")
          .float-left.search_message.mr-1.font-weight-bold 次回更新時の見積書作成
          b-icon.float-right.next-icon(icon="arrow-right-circle")
</template>

<script>
import Loading from '@/components/Loading'
import AppMessages from '@/components/AppMessages';
import BasicPassword from '@/components/BasicPassword';

import Api from '@/repositories/api'
const C206ContractInfo = Api.get('c206ContractInfo');
const S213ContractDetails = Api.get('s213ContractDetails');
const S214Quotation = Api.get('s214Quotation');

import { cl_contract_details_tbl as lang_cl_contract_details_tbl } from '@/lang/ja_JP'

export default {
  name: 'ContractDetails',
  components: {
    Loading,
    AppMessages,
    BasicPassword,
  },
  props: {
    // 販売種別
    sales_channel: { type: String, required: false },
    // 優待価格商品保有フラグ
    has_special_priced_item: { type: Boolean, required: false },
  },
  data() {
    return {
      // 共通のCSS
      neo_service_title_class: 'font-weight-bold ml-3 border-top border-bottom py-2 neo-title-bg-color',
      neo_service_data_class: 'ml-3 py-2 px-2 mb-2 border-top border-bottom border-primary label-font-size',
      neo_option_data_class: 'ml-3 pt-2 px-2 mb-0 border-top border-primary label-font-size',
      chat_service_title_class: 'font-weight-bold ml-3 border-top border-bottom py-2 chat-title-bg-color',
      chat_service_data_class: 'ml-3 py-2 px-2 mb-2 border-top border-bottom border-success label-font-size',
      chat_option_data_class: 'ml-3 pt-2 px-2 mb-0 border-top border-success label-font-size',

      // 定義値
      contractDetailsFlgVar: lang_cl_contract_details_tbl,
      objDefine: {
        // 販売種別
        sales_channel: {
          direct: '0', // 直販
          agency: '1', // 販社
        },
        // 請求単位
        billing_period: {
          month: '0', // 月払い
          year : '1', // 年払い
        },
        neo: {
          mail: {
            cyber: {
              // メールボックス容量
              mailbox: {
                '01': '5',   // 5GB
                '02': '10',  // 10GB
                '03': '50',  // 50GB
                '04': '100', // 100GB
              },
              // オプション
              options: {
                '00': '情報漏えい対策(有償)',
                '01': '添付ファイル暗号化・分離(有償)',
                '02': 'メールアーカイブ＆監査(有償)',
                '03': 'クラウド型サンドボックス(有償)',
              },
              // メール保存期間
              keep: {
                '01': '5',  // 5年
                '02': '7',  // 7年
                '03': '10', // 10年
              }
            }
          },
          mail_security: {
            mailgates: {
              options: {
                '01': 'アンチウイルス・スパム＋サンドボックス',
                '02': '誤送信対策・審査',
                '03': '添付ファイル暗号化・分離',
              }
            }
          }
        }
      },

      // ご契約内容
      objContract: {},

      // ローディングフラグ
      bIsLoading: false,      // 画面全体
      bIsLoadingQuote: false, // 見積書作成ボタン
    }
  },
  computed: {
    /**
     * プランを契約中かどうか（NEO単体も含む）
     */
    hasPlan() {
      return 'light_user' in this.objContract === true
        || 'standard_user' in this.objContract === true
        || 'premium_user' in this.objContract === true
        || 'chatplus_user' in this.objContract === true
        || ('neo' in this.objContract === true && 'neo_user' in this.objContract.neo === true)
    },
    /**
     * NEO オプションサービスを契約中かどうか
     */
    hasNeoOption() {
      return 'neo' in this.objContract === true
        && (
          'app_suite_user' in this.objContract.neo === true
          || 'web_conferencing' in this.objContract.neo === true
          || 'cloud_db_user' in this.objContract.neo === true
          || 'option' in this.objContract.neo === true
          || 'security' in this.objContract.neo === true
          || 'mail' in this.objContract.neo === true
          || 'mail_security' in this.objContract.neo === true
        )
    },
    /**
     * Chat オプションサービスを契約中かどうか
     */
    hasChatOption() {
      return 'chat' in this.objContract === true
        && (
          'option' in this.objContract.chat === true
          || 'security' in this.objContract.chat === true
        )
    },
    /**
     * 見積書作成可能かどうか
     */
    enableCreateQuote() {
      return this.sales_channel === this.objDefine.sales_channel.direct // 直販
        && this.has_special_priced_item === false // 優待価格商品を保有していない
        && (
          // 年払い
          ('neo' in this.objContract === true && this.objContract.neo.billing_period === this.objDefine.billing_period.year)
          || ('chat' in this.objContract === true && this.objContract.chat.billing_period === this.objDefine.billing_period.year)
        )
    }
  },
  created() {
    // ローディングを開始する
    this.bIsLoading = true

    // 画面パラメータに契約番号が存在する場合
    if ('contract_no' in this.$route.params) {
      // 「S21301_契約内容取得処理」を実行する
      this.getServiceData(this.$route.params.contract_no)
    }
    // 画面パラメータに契約番号が存在しない場合
    else {
      // 「C20601_契約情報取得処理」を実行する
      C206ContractInfo.get()
        // 処理に成功した場合
        .then((response) => {
          // 取得した契約情報数が1件の場合
          if (response.data.data.length === 1) {
            // 「S21301_契約内容取得処理」を実行する
            this.getServiceData(response.data.data[0].contract_no)
          }
          else {
            // セッションストレージにデータを保存する
            sessionStorage.setItem('previous', 'ContractDetails') // 前画面

            // 「S11500_ご契約環境選択」画面に遷移する
            this.$router.push({ name: 'ContractSelect' })
          }
        })
        // 処理に失敗した場合
        .catch((error) => {
          // 共通エラー処理
          this.apiError(error, '画面表示処理', 'Service')
          // エラーメッセージを表示する
          this.setErrors(error)
          // ローディングを終了する
          this.bIsLoading = false
        })
    }
  },
  methods: {
    /**
     * ご契約内容を取得する
     *
     * @param {string} sContractNo 契約番号
     */
    getServiceData(sContractNo) {
      // 「S21301_契約内容取得処理」を実行する
      S213ContractDetails.view({contract_no: sContractNo})
        // 処理に成功した場合
        .then((response) => {
          // レスポンスを画面に埋め込む
          const objResponseData = response.data.data[0]

          // レスポンスを整形する
          // 契約番号
          this.objContract.contract_no = objResponseData.contract_no

          // セットプラン
          // ライト
          if ('light_user' in objResponseData === true) {
            this.objContract.light_user = objResponseData.light_user
          }
          // スタンダード
          if ('standard_user' in objResponseData === true) {
            this.objContract.standard_user = objResponseData.standard_user
          }
          // プレミアム
          if ('premium_user' in objResponseData === true) {
            this.objContract.premium_user = objResponseData.premium_user
          }
          // チャットプラス
          if ('chatplus_user' in objResponseData === true) {
            this.objContract.chatplus_user = objResponseData.chatplus_user
          }

          // desknet's NEO 情報
          if ('neo' in objResponseData) {
            const objNeo = objResponseData.neo
            this.objContract.neo = {}

            // 請求単位
            this.objContract.neo.billing_period = objNeo.billing_period

            // desknet's NEO ユーザー数
            if ('neo_user' in objNeo === true) {
              this.objContract.neo.neo_user = objNeo.neo_user
            }
            // AppSuite（価格改定後）
            if ('app_suite_user' in objNeo === true) {
              this.objContract.neo.app_suite_user = objNeo.app_suite_user
            }
            // AppSuite（価格改定前）
            if ('app_suite_user_old' in objNeo === true) {
              this.objContract.neo.app_suite_user = objNeo.app_suite_user_old
            }
            // ウェブ会議
            if ('web_conferencing' in objNeo === true) {
              this.objContract.neo.web_conferencing = objNeo.web_conferencing
            }
            // desknet's DB
            if ('cloud_db_user' in objNeo === true) {
              this.objContract.neo.cloud_db_user = objNeo.cloud_db_user
            }

            // オプションサービス
            if ('option' in objNeo === true) {
              const objNeoOption = objNeo.option
              this.objContract.neo.option = {}

              // RoomMgr
              if ('room_mgr' in objNeoOption === true && objNeoOption.room_mgr === true) {
                this.objContract.neo.option.room_mgr = objNeoOption.room_mgr
              }
              // 交通費・経費精算
              if ('expense_settlement' in objNeoOption === true && objNeoOption.expense_settlement === true) {
                this.objContract.neo.option.expense_settlement = objNeoOption.expense_settlement
              }
              // タイムカード＋CLOUZA
              if ('clouza' in objNeoOption === true) {
                this.objContract.neo.option.clouza = {}

                // ユーザー数
                if ('user' in objNeoOption.clouza === true) {
                  this.objContract.neo.option.clouza.user = objNeoOption.clouza.user
                }
                // CLOUZA会社コード
                if (
                  'clouza_company' in objNeoOption.clouza === true
                  && objNeoOption.clouza.clouza_company !== null
                  && objNeoOption.clouza.clouza_company !== ''
                ) {
                  this.objContract.neo.option.clouza.clouza_company = objNeoOption.clouza.clouza_company
                }
                // 有休管理＋申請オプション
                if ('paid_leave_option' in objNeoOption.clouza === true && objNeoOption.clouza.paid_leave_option === true) {
                  this.objContract.neo.option.clouza.paid_leave_option = objNeoOption.clouza.paid_leave_option
                }
              }
              // ディスク増設
              if ('disk' in objNeoOption === true) {
                this.objContract.neo.option.disk = {}

                // 増設容量（価格改定後）
                if ('disk_size' in objNeoOption.disk === true) {
                  this.objContract.neo.option.disk.disk_size = objNeoOption.disk.disk_size
                }
                // 増設容量（価格改定前）
                if ('disk_size_old' in objNeoOption.disk === true) {
                  this.objContract.neo.option.disk.disk_size = objNeoOption.disk.disk_size_old
                }
              }
              // Sync for smartphones
              if ('sync' in objNeoOption === true) {
                this.objContract.neo.option.sync = {}

                // ユーザー数
                if ('user' in objNeoOption.sync === true) {
                  this.objContract.neo.option.sync.user = objNeoOption.sync.user
                }
              }
              // desknet'sドライブ ディスク増設
              if ('dn_drive' in objNeoOption === true) {
                this.objContract.neo.option.dn_drive = {}

                // 増設容量
                if ('disk_size' in objNeoOption.dn_drive === true) {
                  this.objContract.neo.option.dn_drive.disk_size = objNeoOption.dn_drive.disk_size
                }
              }
            }

            // セキュリティオプション
            if ('security' in objNeo === true) {
              const objNeoSecutiry = objNeo.security
              this.objContract.neo.security = {}

              // BASIC認証
              if ('basic' in objNeoSecutiry === true) {
                this.objContract.neo.security.basic = {}

                // ユーザーID
                if ('basic_id' in objNeoSecutiry.basic === true) {
                  this.objContract.neo.security.basic.basic_id = objNeoSecutiry.basic.basic_id
                }
                // パスワード
                if ('basic_password' in objNeoSecutiry.basic === true) {
                  this.objContract.neo.security.basic.basic_password = objNeoSecutiry.basic.basic_password
                }
                // 認証を除外するIPアドレス
                if (
                  'basic_except_ip' in objNeoSecutiry.basic === true
                  && objNeoSecutiry.basic.basic_except_ip !== null
                  && objNeoSecutiry.basic.basic_except_ip !== ''
                ) {
                  // IPアドレスを5件毎に改行する
                  this.objContract.neo.security.basic.basic_except_ip = this.spritIp(objNeoSecutiry.basic.basic_except_ip)
                }
              }
              // 接続元IPアドレス制限
              if ('connect_permit_ip' in objNeoSecutiry === true) {
                // IPアドレスを5件毎に改行する
                this.objContract.neo.security.connect_permit_ip = this.spritIp(objNeoSecutiry.connect_permit_ip)
              }
              // セキュアブラウザ
              if ('secure' in objNeoSecutiry === true) {
                this.objContract.neo.security.secure = {}

                // 端末認証
                if ('secure_browser_terminal' in objNeoSecutiry.secure === true) {
                  this.objContract.neo.security.secure.secure_browser_terminal = objNeoSecutiry.secure.secure_browser_terminal
                }
                // デバイス数
                if ('secure_browser_device' in objNeoSecutiry.secure === true) {
                  this.objContract.neo.security.secure.secure_browser_device = objNeoSecutiry.secure.secure_browser_device
                }
                // セキュアブラウザを適用しないIPアドレス
                if (
                  'secure_except_ip' in objNeoSecutiry.secure === true
                  && objNeoSecutiry.secure.secure_except_ip !== null
                  && objNeoSecutiry.secure.secure_except_ip !== ''
                ) {
                  // IPアドレスを5件毎に改行する
                  this.objContract.neo.security.secure.secure_except_ip = this.spritIp(objNeoSecutiry.secure.secure_except_ip)
                }
              }
              // クライアント認証
              if ('client' in objNeoSecutiry === true) {
                this.objContract.neo.security.client = {}

                // デバイス数
                if ('device' in objNeoSecutiry.client === true) {
                  this.objContract.neo.security.client.device = objNeoSecutiry.client.device
                }
                // 認証を除外するIPアドレス
                if ('cert_except_ip' in objNeoSecutiry.client === true
                  && objNeoSecutiry.client.cert_except_ip !== null
                  && objNeoSecutiry.client.cert_except_ip !== ''
                ) {
                  // IPアドレスを5件毎に改行する
                  this.objContract.neo.security.client.cert_except_ip = this.spritIp(objNeoSecutiry.client.cert_except_ip)
                }
              }
            }

            // メールサービス
            if ('mail' in objNeo === true) {
              const objNeoMail = objNeo.mail
              this.objContract.neo.mail = {}

              // WebARENA
              if ('arena' in objNeoMail === true) {
                this.objContract.neo.mail.arena = {}

                // ドメイン名
                if ('wa_domain' in objNeoMail.arena === true) {
                  this.objContract.neo.mail.arena.wa_domain = objNeoMail.arena.wa_domain
                }
                // アカウント数
                if ('account' in objNeoMail.arena === true) {
                  this.objContract.neo.mail.arena.account = objNeoMail.arena.account
                }
              }
              // CYBERMAILΣ
              if ('cyber' in objNeoMail === true) {
                this.objContract.neo.mail.cyber = {}

                // アカウント数
                if ('account' in objNeoMail.cyber === true) {
                  this.objContract.neo.mail.cyber.account = objNeoMail.cyber.account
                }
                // メールボックス容量
                if ('mailbox' in objNeoMail.cyber === true) {
                  this.objContract.neo.mail.cyber.mailbox = objNeoMail.cyber.mailbox
                }
                // オプション
                if ('options' in objNeoMail.cyber === true) {
                  this.objContract.neo.mail.cyber.options = objNeoMail.cyber.options
                }
                // 保存期間
                if ('keep' in objNeoMail.cyber === true) {
                  this.objContract.neo.mail.cyber.keep = objNeoMail.cyber.keep
                }
              }
            }

            // メールセキュリティサービス
            if ('mail_security' in objNeo === true) {
              const objNeoMailSecurity = objNeo.mail_security
              this.objContract.neo.mail_security = {}

              // MAILEGASTESΣ
              if ('mailgates' in objNeoMailSecurity === true) {
                this.objContract.neo.mail_security.mailgates = {}

                // ドメイン名
                if ('mailgates_domain' in objNeoMailSecurity.mailgates === true) {
                  this.objContract.neo.mail_security.mailgates.mailgates_domain = objNeoMailSecurity.mailgates.mailgates_domain
                }
                // アカウント数
                if ('account' in objNeoMailSecurity.mailgates === true) {
                  this.objContract.neo.mail_security.mailgates.account = objNeoMailSecurity.mailgates.account
                }
                // オプション
                if ('options' in objNeoMailSecurity.mailgates === true) {
                  this.objContract.neo.mail_security.mailgates.options = objNeoMailSecurity.mailgates.options
                }
              }
            }
          }

          // ChatLuck 情報
          if ('chat' in objResponseData) {
            const objChat = objResponseData.chat
            this.objContract.chat = {}

            // 請求単位
            this.objContract.chat.billing_period = objChat.billing_period

            // ChatLuck ユーザー数
            if ('chat_user' in objChat === true) {
              this.objContract.chat.chat_user = objChat.chat_user
            }

            // オプションサービス
            if ('option' in objChat === true) {
              const objChatOption = objChat.option
              this.objContract.chat.option = {}

              // ディスク増設
              if ('disk' in objChatOption === true) {
                this.objContract.chat.option.disk = {}

                // （価格改定後）
                if ('disk_size' in objChatOption.disk === true) {
                  this.objContract.chat.option.disk.disk_size = objChatOption.disk.disk_size
                }
                // （価格改定前）
                if ('disk_size_old' in objChatOption.disk === true) {
                  this.objContract.chat.option.disk.disk_size = objChatOption.disk.disk_size_old
                }
              }
            }

            // セキュリティオプション
            if ('security' in objChat === true) {
              const objChatSecutiry = objChat.security
              this.objContract.chat.security = {}

              // BASIC認証
              if ('basic' in objChatSecutiry === true) {
                this.objContract.chat.security.basic = {}

                // ユーザーID
                if ('basic_id' in objChatSecutiry.basic === true) {
                  this.objContract.chat.security.basic.basic_id = objChatSecutiry.basic.basic_id
                }
                // パスワード
                if ('basic_password' in objChatSecutiry.basic === true) {
                  this.objContract.chat.security.basic.basic_password = objChatSecutiry.basic.basic_password
                }
                // 認証を除外するIPアドレス
                if ('basic_except_ip' in objChatSecutiry.basic === true
                  && objChatSecutiry.basic.basic_except_ip !== null
                  && objChatSecutiry.basic.basic_except_ip !== ''
                ) {
                  // IPアドレスを5件毎に改行する
                  this.objContract.chat.security.basic.basic_except_ip = this.spritIp(objChatSecutiry.basic.basic_except_ip)
                }
              }
              // 接続元IPアドレス制限
              if ('connect_permit_ip' in objChatSecutiry === true) {
                // IPアドレスを5件毎に改行する
                this.objContract.chat.security.connect_permit_ip = this.spritIp(objChatSecutiry.connect_permit_ip)
              }
            }
          }
        })
        // 処理に失敗した場合
        .catch((error) => {
          // 共通エラー処理
          this.apiError(error, '画面表示処理', 'Service')
          // エラーメッセージを表示する
          this.setErrors(error)
        })
        // 処理が終了した場合
        .finally(() => {
          // ローディングを終了する
          this.bIsLoading = false
        })
    },
    /**
     * IPアドレスを5件毎に改行する
     */
    spritIp(sIp) {
      // IPアドレス１個ずつ配列に格納
      let ipAry = sIp.split('\n')
      let ipLength = ipAry.length

      // IPアドレス5件毎に改行をする
      if (ipLength > 1) {
        for (let i = 1; i <= ipAry.length; i++) {
          if ((i % 5 !== 0 && i !== ipAry.length) || i === 1) {
            ipAry[i - 1] = ipAry[i - 1] + ', '
          }
          else if (i % 5 === 0 && i !== ipAry.length) {
            ipAry[i - 1] = ipAry[i - 1] + '\n'
          }
        }
      }

      return ipAry.join('')
    },
    /**
     * 見積書を作成する
     */
    createQuote() {
      // 見積書作成ボタンを無効にする
      this.bIsLoadingQuote = true
      // エラーメッセージをリセットする
      this.resetErrors()

      // 「S21408_更新見積書作成処理」を実行する
      S214Quotation.createUpdateQuotation({
        // 契約番号
        contract_no: Number(this.objContract.contract_no),
      })
        // 処理に成功した場合
        .then((response) => {
          // 「S21404_見積書取得処理」を実行する
          S214Quotation.get({
            // 見積枝番
            estimate_branch: response.data.data.estimate_branch[0],
          })
            // 処理に成功した場合
            .then((response) => {
              // ファイル名を取得する
              let title = response.headers['content-disposition'].replace('attachment; filename*=UTF-8\'\'', '')
              // PDFをダウンロードする
              this.downloadBlobFile(response.data, title, 'application/pdf')
            })
            // 処理に失敗した場合
            .catch((error) => {
              // 共通エラー処理
              this.apiError(error, '画面表示処理', 'Service')
              // エラーメッセージを表示する
              this.setErrors(error)
              // 画面TOPまでスクロールをする
              this.pageTopScroll()
            })
            // 処理が終了した場合
            .finally(() => {
              // 見積書作成ボタンを有効にする
              this.bIsLoadingQuote = false
            })
        })
        // 処理に失敗した場合
        .catch((error) => {
          // 共通エラー処理
          this.apiError(error, '画面表示処理', 'Service')
          // エラーメッセージを表示する
          this.setErrors(error)
          // 見積書作成ボタンを有効にする
          this.bIsLoadingQuote = false
          // 画面TOPまでスクロールをする
          this.pageTopScroll()
        })
    },
  }
}
</script>

<style scoped>
.plan-title-bg-color {
  background-color: #fceaee;
}
.neo-title-bg-color {
  background-color: #f2ffff;
}
.chat-title-bg-color {
  background-color: #f0ffe0;
}
.border-plan {
  border-color: #eb6ea0 !important;
}
.label-font-size {
  font-size: 16px;
}
.white-space {
  white-space: pre-line;
}
.title-bg-color {
  background-color: #f2ffff;
}
img {
  width: 100px;
  height: auto;
}
</style>
